import { BorderRadius, Color } from '@billy/design-system'
import { StyleSheet } from '@react-pdf/renderer'

export const pdfStyles = StyleSheet.create({
  table: {
    width: 'auto',
    borderWidth: 1,
    borderBottomWidth: 0,
    borderRightWidth: 0,
    borderColor: Color.Grey200,
    borderStyle: 'solid',
    borderRadius: BorderRadius.R8,
    overflow: 'hidden',
  },
})
